import React, { useEffect, useState } from 'react'
import NavTitle from '../../../components/nav-title'
import TextNavTitle from '../../../components/TextNavTitle'
import CardCustom from '../../../components/custom/card-custom'
import { Col, Form, Row, Table } from 'react-bootstrap'
import BtnBack from '../../../components/btn-back'
import { PAGE_INCOME_KYS } from '../../../router/routes'
import { Link, useSearchParams } from 'react-router-dom'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import { detailIncomeLoanSLFAPI } from '../../../services/income/loan-slf'
import { fnDateEn } from '../../../helper/fnDateEn'
import { Controller, useForm } from 'react-hook-form'
import InputSearchCustom from '../../../components/custom/InputSearchCustom'
import { FaAnglesRight } from 'react-icons/fa6'

export default function DetailIncomeSLFPage() {
  let [searchParams] = useSearchParams()
  const id = searchParams.get('id')
  const orgId = searchParams.get('orgId')

  const totalLimits = 20
  const [page, setPage] = useState(1)
  const [bodyFilter, setBodyFilter] = useState()
  const [totalRows, setTotalRows] = useState(0)

  useEffect(() => {
    const body = {
      periodDate: id,
      page: 1,
      orgId,
      size: totalLimits
    }
    if (orgId && id) {
      fnGetData(body)
    }
  }, [id, orgId])
  const [dataTable, setDataTable] = useState([])
  const fnGetData = async (body) => {
    setBodyFilter(body)
    const resp = await detailIncomeLoanSLFAPI(body)
    if (!resp) return
    if (resp.result) {
      setDataTable(resp.result)
      setTotalRows(resp.totalRows)
    } else {
      setDataTable([])
      setTotalRows(0)
    }
  }

  const { control, handleSubmit } = useForm({})
  const onClearSearch = () => {
    const body = {
      ...bodyFilter,
      page: 1,
      searchs: ''
    }
    fnGetData(body)
  }
  const onSearch = (d) => {
    const body = {
      ...bodyFilter,
      page: 1,
      searchs: d.search
    }
    fnGetData(body)
  }

  return (
    <div>
      <NavTitle>
        <TextNavTitle>
          <Link
            to={-1}
            className={`my-auto text-reset text-decoration-none pointer-event`}
          >
            กยศ.
            <FaAnglesRight />
            <label className="small fw-medium ms-2">
              Periods: {fnDateEn(id).format('MM/YYYY')}
            </label>
          </Link>
        </TextNavTitle>
      </NavTitle>

      <CardCustom className="d-flex justify-content-between ">
        <div>
          <div className="p-3 ">
            <Row>
              <Col md={4}>
                <span className="mb-0 small">Total: {totalRows}</span>
              </Col>
              <Col md={8} className="d-flex justify-content-end">
                <Form className="from-search" onSubmit={handleSubmit(onSearch)}>
                  <div style={{ minWidth: 280 }}>
                    <Controller
                      name={'search'}
                      control={control}
                      render={({ field: { onChange, value = '' } }) => (
                        <InputSearchCustom
                          value={value}
                          onChange={(d) => {
                            onChange(d)

                            if (!d) {
                              onClearSearch()
                            }
                          }}
                          placeholder="Search"
                        />
                      )}
                    />
                  </div>
                </Form>
              </Col>
            </Row>
          </div>
          <Table hover>
            <thead
              className="bg-hrms text-white "
              style={{ position: 'sticky', top: '0px' }}
            >
              <tr className=" font-title-table">
                <th className="fw-normal">#</th>
                <th className="fw-normal">ORG</th>
                <th className="fw-normal">Code</th>
                <th className="fw-normal">Name</th>
                <th className="fw-normal">ID Card</th>
                <th className="text-end fw-normal">Amount</th>
              </tr>
            </thead>
            <tbody>
              {dataTable.length > 0 ? (
                dataTable.map((d, i) => (
                  <tr key={i} className="font-small-2 align-middle">
                    <td>{page * totalLimits - totalLimits + i + 1}</td>
                    <td>{d.org}</td>
                    <td>{d.code}</td>
                    <td>
                      {d.titleTh}
                      {d.nameTh} {d.surnameTh}
                    </td>
                    <td>{d.idCard}</td>
                    <td className="text-end">
                      {d.slfAmounts?.toLocaleString()}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="text-center" colSpan={6}>
                    - No Data -
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className="p-3">
          <PaginationControl
            page={page}
            total={totalRows}
            limit={totalLimits}
            changePage={(p) => {
              const body = {
                ...bodyFilter,
                page: p
              }
              fnGetData(body)
              setPage(p)
            }}
            ellipsis={1}
          />
        </div>
      </CardCustom>
    </div>
  )
}
